<andor-select-field
  [title]="'Server Region' | translate"
  [options]="options()"
  [selectedOption]="selected()"
  [autoSelectFirst]="false"
  [required]="required()"
  [placeholder]="'Select a server region' | translate"
  (selected)="select($event)"
  [forceDisabled]="loading() || disabled()"
  [toolTipMsg]="
    'Select the server region closest to your audience for optimal connection and reduced latency'
      | translate
  ">
  <ng-template #optionIcon let-option>
    <ng-container
      [ngTemplateOutlet]="regionSymbol"
      [ngTemplateOutletContext]="{ $implicit: option.id }" />
  </ng-template>
  <span select-leading class="region-symbol">
    <ng-container
      [ngTemplateOutlet]="regionSymbol"
      [ngTemplateOutletContext]="{ $implicit: selected()?.id }" />
  </span>
</andor-select-field>
<ng-template #regionSymbol let-region>
  <fa-duotone-icon [icon]="regionIcons[region ?? ''] ?? faGlobe" />
</ng-template>
@if (loading()) {
  <p class="field-note" role="status">{{ 'Finding available regions…' | translate }}</p>
} @else if (error()) {
  <p class="field-note" role="status">
    {{ 'Could not load regions. Please retry.' | translate }}
    <button class="text-button" type="button" (click)="load()">
      {{ 'Retry' | translate }}
    </button>
  </p>
} @else if (hint()) {
  <p class="field-note">{{ hint() }}</p>
}
